<template>
  <div
    ref="defaultCollection"
    :class="altBackground ? 'koc-view koc-default-collection alt' : 'koc-view koc-default-collection'"
  >
    <Modal
      :item="state.modalItem"
      :show="state.showModal"
      :user="state.member"
      @toggle-modal="toggleModal"
    />
    <div
      v-if="collectionType === 'magazines' && state.filters"
      class="koc-default-collection-tabs"
    >
      <div
        class="koc-default-collection-tabs-tab koc-title koc-montserrat"
        :class="state.select.toLowerCase() === 'all magazines' ? 'koc-default-collection-tabs-tab-active' : ''"
        @click="filterResults('all')"
      >
        All Publications
      </div>
      <div
        v-for="filter in state.filters"
        :key="filter.id"
        class="koc-default-collection-tabs-tab koc-title koc-montserrat"
        :class="state.filteredId == filter.id ? 'koc-default-collection-tabs-tab-active' : ''"
        @click="filterResults(filter.id)"
      >
        {{ filter.label }}
      </div>
    </div>
    <div
      v-if="state.filters && collectionType !== 'magazines' && state.filterType"
      class="koc-default-collection-select"
    >
      <div class="koc-default-collection-select-title koc-title koc-montserrat">
        {{ state.label }}
      </div>
      <div
        :class="state.openOptions ? 'koc-default-collection-select-dropdown-active' : 'koc-default-collection-select-dropdown'"
        @click="state.openOptions = !state.openOptions"
      >
        <div class="koc-default-collection-select-dropdown-selected koc-title koc-montserrat">
          {{ state.select }}
        </div>
        <div class="koc-default-collection-select-dropdown-icon">
          <font-awesome-icon
            :icon="state.openOptions ? 'angle-up' : 'angle-down'"
            class="koc-dropdown-caret koc-title-2"
          />
        </div>
        <div
          v-if="state.openOptions"
          class="koc-default-collection-select-dropdown-options"
        >
          <div
            v-if="state.select.toLowerCase() !== `all ${collectionType.toLowerCase()}`"
            class="koc-default-collection-select-dropdown-options-option koc-title koc-montserrat"
            @click="filterResults('all')"
          >
            All {{ collectionType }}
          </div>
          <div
            v-for="filter in state.filters"
            :key="filter.id"
          >
            <div
              v-if="state.filteredId != filter.id"
              class="koc-default-collection-select-dropdown-options-option koc-title koc-montserrat"
              @click="filterResults(filter.id)"
            >
              {{ filter.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="collectionType === 'instructors'"
      class="koc-default-collection-select"
    >
      <div class="koc-default-collection-select-title-instructors koc-title koc-montserrat">
        Instructors
      </div>
    </div>
    <div class="koc-default-collection-innerwrapper">
      <main
        v-if="!state.loaded"
        class="koc-default-collection-items"
      >
        <div
          v-for="n in state.skeletonCount"
          :key="n"
          class="koc-default-collection-item"
          :class="collectionType === 'magazines' ? 'koc-default-collection-item-alt' : collectionType === 'instructors' ? 'koc-default-collection-item-instructor' : 'koc-default-collection-item'"
        >
          <SkeletonLoader
            v-if="collectionType === 'courses'"
            :image="true"
            :content="true"
            :content-body="1"
            :content-body-flex="true"
            :footer="true"
            :footer-icons="3"
          />
          <SkeletonLoader
            v-else-if="collectionType === 'toolkits'"
            :image="true"
            :content="true"
            :footer="true"
            :footer-icons="1"
          />
          <SkeletonLoader
            v-else-if="collectionType === 'tracks'"
            :image="true"
            :content="true"
            :content-body="1"
            :footer="true"
          />
          <SkeletonLoader
            v-else-if="collectionType === 'articles'"
            :image="true"
            :content="true"
            :content-body="1"
            :footer="true"
          />
          <SkeletonLoader
            v-else-if="collectionType === 'tutorials'"
            :image="true"
            :content="true"
            :content-body="1"
            :footer="true"
          />
          <SkeletonLoader
            v-else-if="collectionType === 'discounts'"
            :image="true"
            :content="true"
            :content-body="1"
          />
          <SkeletonLoader
            v-else-if="collectionType === 'webcasts'"
            :image="true"
            :content="true"
            :footer="true"
            :footer-icons="1"
          />
          <SkeletonLoader
            v-else-if="collectionType === 'magazines'"
            item="magazine"
          />
          <SkeletonLoader
            v-else-if="collectionType === 'lessons'"
            :image="true"
            :content="true"
            :content-body="2"
            :footer="true"
          />
          <SkeletonLoader
            v-else-if="collectionType === 'instructors'"
            item="instructor"
            :is-mobile="state.width < 1200"
          />
          <SkeletonLoader
            v-else
            :image="true"
            :content="true"
            :content-body="1"
            :footer="true"
            :footer-icons="2"
          />
        </div>
      </main>
      <main
        v-else
        class="koc-default-collection-items"
      >
        <div
          v-if="state.outOfBounds || !state.data"
          class="koc-default-collection-items-no-results"
        >
          <h1 class="koc-default-collection-items-no-results-title">
            No Results Found
          </h1>
        </div>
        <div
          v-for="item in state.data"
          v-else
          :key="item.id"
          :class="item.type === 'magazine' ? 'koc-default-collection-item-alt' : item.type === 'instructor' ? 'koc-default-collection-item-instructor' : 'koc-default-collection-item'"
        >
          <Toolkit
            v-if="item.type === 'toolkit'"
            :item="item"
            :user="state.member"
            @toggle-modal="toggleModal"
          />
          <Discount
            v-if="item.type === 'discount'"
            :item="item"
            :user="state.member"
          />
          <Tutorial
            v-if="item.type === 'tutorial'"
            :item="item"
            :user="state.member"
          />
          <Track
            v-if="item.type === 'track'"
            :item="item"
            :user="state.member"
          />
          <Webcast
            v-if="item.type === 'webcast'"
            :item="item"
            :user="state.member"
            @toggle-modal="toggleModal"
          />
          <Article
            v-if="item.type === 'article'"
            :item="item"
            :user="state.member"
          />
          <Course
            v-if="item.type === 'course'"
            :item="item"
            :user="state.member"
            :reload="reload"
            @toggle-modal="toggleModal"
            @reload-section="reloadSection"
          />
          <Magazine
            v-if="item.type === 'magazine'"
            :item="item"
            :user="state.member"
            @toggle-modal="toggleModal"
          />
          <Lesson
            v-if="item.type === 'lesson'"
            :item="item"
            :user="state.member"
          />
          <Instructor
            v-if="item.type === 'instructor'"
            :item="item"
            :user="state.member"
            :width="state.width"
          />
          <EventSession
            v-if="item.type === 'event_session'"
            :item="item"
            :user="state.member"
            @toggle-modal="toggleModal"
          />
        </div>
      </main>
    </div>
    <footer
      v-if="!state.loading && state.hasPagination"
      class="koc-section-footer"
    >
      <pagination-component
        :pagination="state.getPagination"
        @change="paginate"
      />
    </footer>
  </div>
</template>

<script src="./default-collection.js"></script>
<style lang="scss" scoped src="./default-collection.scss"></style>
